export default { 
    login_social_media_error_default: 'Incorrect Username or Password',
    login_social_media_error_presignin: 'PreSignUp failed with error ',
    login_social_media_error_preauthentication:'PreAuthentication failed with error',
    login_social_media_error: 'Error durante el proceso de inicio de sesión',
}